export const PERMISSOES = {
  ACESSAR_HOME: "acessar_home",
  GESTAO_QUARTOS: "gestao_quartos",
  INSCRICAO_RETIRO: "inscricao_retiro",
  INSCRICAO_RETIRO_EQUIPE: "inscricao_retiro_equipe",
  LISTAR_INSCRITOS_RETIRO: "listar_inscritos_retiro",
  EDITAR_INSCRICAO_RETIRO: "editar_inscricao_retiro",
  ENCERRAR_INSCRICOES_RETIRO: "encerrar_inscricoes_retiro",
  ENCERRAR_INSCRICOES_EQUIPE: "encerrar_inscricoes_equipe",
  CADASTRAR_PAGAMENTO: "cadastrar_pagamento",
  CADASTRAR_USUARIO: "cadastrar_usuario",
  LISTAR_USUARIOS: "listar_usuarios",
  EDITAR_USUARIO: "editar_usuario",
  EXCLUIR_USUARIO: "excluir_usuario",
  CADASTRAR_MEDICAMENTO: "cadastrar_medicamento",
  LISTAR_MEDICAMENTOS: "listar_medicamentos",
  EDITAR_MEDICAMENTO: "editar_medicamento",
  EXCLUIR_MEDICAMENTO: "excluir_medicamento",
  CADASTRAR_CATALOGO_MEDICAMENTO: "cadastrar_catalogo_medicamento",
  LISTAR_CATALOGO_MEDICAMENTO: "listar_catalogo_medicamento",
  EDITAR_CATALOGO_MEDICAMENTO: "editar_catalogo_medicamento",
  EXCLUIR_CATALOGO_MEDICAMENTO: "excluir_catalogo_medicamento",
  GERENCIAR_FILA: "gerenciar_fila",
  PAINEL_FILA: "painel_fila",
  GERENCIAR_PERMISSOES: "gerenciar_permissoes",
};

export const temPermissao = (permissoes, permissao) => {
  if (!permissao) return true;
  if (!Array.isArray(permissoes)) return false;
  return permissoes.includes(permissao);
};
